<template>
  <div
    id="app"
    :class="[
      themeMode ? themeMode : '',
      screenMode,
      platfromMode,
      isIosFlag ? 'iosClient' : 'androidClient',
    ]"
  >
    <transition name="fade" mode="out-in">
      <!-- <keep-alive> -->
      <router-view></router-view>
      <!-- </keep-alive> -->
    </transition>
    <loading v-show="isShowLoading" :zIndex="11000"></loading>
    <numberedMode v-show="platfromMode == 'mixtmt_h5'"></numberedMode>
  </div>
</template>

<script>
import platfrom_app_data_mixin from '@mixins/platfrom_app_data'
import eventBus from '@src/eventBus'
import loading from '@components/base/loading'
import numberedMode from '@components/base/numbered_mode'
export default {
  name: 'app',
  components: { loading, numberedMode },
  mixins: [platfrom_app_data_mixin],
  data() {
    return {
      isShowLoading: true,
    }
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route(to, from) {
      console.debug('route change:', to, from, this.$router)
    },
  },
  beforeCreate() {
    console.debug(this.$route)
    window.mixtmtBase_eventBus = eventBus
    window.mixtmt_platfrom = {
      isShowLoading: true,
      currLoadingPage: this.$route.name,
    }

    window.axiosErrTimeOut = 0
    window.mixtmtBase_eventBus.$on('loadingEvent', (flag) => {
      // console.debug('loadingEvent on')
      this.isShowLoading = flag
      window.mixtmt_platfrom.isShowLoading = flag
      window.mixtmt_platfrom.currLoadingPage = this.$route.name
    })
    // console.debug(window.isCCTVAppH5);
    window.addEventListener('offline', () => {
      window.axiosErrTimeOut = 1000
    })
  },
  mounted() {
    window.mixtmt_platfrom.envOtherOption = this.envOtherOption()
  },
}
</script>
<style lang="scss">
.v-modal {
  z-index: 1600 !important;
}
.el-message {
  z-index: 1650 !important;
}
* {
  touch-action: pan-y;
}

.slideR2L {
  -webkit-animation: slideR2L 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slideR2L 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes slideR2L {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slideR2L {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

.slideL2R {
  -webkit-animation: slideL2R 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slideL2R 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes slideL2R {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slideL2R {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
</style>
